import classNames from 'classnames';
import { Icon } from 'components';
import React from 'react';
import titleize from 'titleize';
import { equals } from 'ramda';
import SimpleLabel from './SimpleLabel';

const mapStatusToIcon = (status, collectionStatus) => {
  switch (collectionStatus) {
    case 'incomplete':
      return <Icon customIcon="remove" />;
    case 'complete':
      return <Icon customIcon="completed" />;
    case '360Complete':
      return <Icon customIcon="completed" />;
    default:
      return (
        <Icon customIcon={status === 'blocked' ? status : collectionStatus} />
      );
  }
};

const mapStatusToClass = (collectionStatus) => {
  if (equals(collectionStatus, '360Complete')) return 'complete-360';
  return collectionStatus;
};

const mapStatusToText = (collectionStatus) => {
  const labelTexts = {
    completed: 'Completed',
    complete: 'Complete',
    notStarted: 'Not Started',
    inProgress: 'In Progress',
    incomplete: 'Incomplete',
    '360Complete': '360 complete',
  };
  return labelTexts[collectionStatus] ?? titleize(collectionStatus);
};

const MatchStatus = ({
  status = '', // used for blocked matches
  className,
  collectionStatus = '',
  ...rest
}) => {
  return (
    <div
      className={classNames(
        'match-status-label',
        className,
        mapStatusToClass(collectionStatus),
        status
      )}
      {...rest}
    >
      {mapStatusToIcon(status, collectionStatus)}
      <SimpleLabel labelText={mapStatusToText(collectionStatus)} />
    </div>
  );
};

export default MatchStatus;
